import classNames from 'classnames'

import { IconButton } from '@ui/components/Button'
import { Tooltip } from '@ui/components/Tooltip/Tooltip'
import { CloseIcon } from '@ui/icons/Close.icon'
import { InfoIcon } from '@ui/icons/Info.icon'

import styles from './RowActions.module.scss'

type Props = {
  onInfoClick?: () => void
  onCloseClick?: () => void
  infoAriaLabel?: string
  closeAriaLabel?: string
  closeTooltip: string
  className?: string
}

export const RowActions = ({
  onInfoClick,
  onCloseClick,
  infoAriaLabel = 'Info',
  closeAriaLabel = 'Close',
  closeTooltip,
  className,
}: Props) => {
  return (
    <div className={classNames(styles.actions, className)}>
      <IconButton.Ghost
        aria-label={infoAriaLabel}
        onClick={(e) => {
          e.stopPropagation()
          onInfoClick?.()
        }}
        icon={{ icon: InfoIcon, color: 'text-low-em' }}
      />

      <Tooltip content={closeTooltip}>
        <IconButton.Secondary
          aria-label={closeAriaLabel}
          onClick={(e) => {
            e.stopPropagation()
            onCloseClick?.()
          }}
          icon={CloseIcon}
          size='sm'
        />
      </Tooltip>
    </div>
  )
}

export default RowActions
